// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/workflow_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { SuggestionEntityType } from "./suggestions_pb.ts";

/**
 * @generated from message protogen.RunWorkflowRequest
 */
export class RunWorkflowRequest extends Message<RunWorkflowRequest> {
  /**
   * @generated from field: string workflowName = 1;
   */
  workflowName = "";

  /**
   * @generated from field: repeated protogen.RunWorkflowRequest.WorkflowArgument arguments = 2;
   */
  arguments: RunWorkflowRequest_WorkflowArgument[] = [];

  /**
   * @generated from field: protogen.SuggestionEntityType entityType = 3;
   */
  entityType = SuggestionEntityType.UNKNOWN;

  /**
   * @generated from field: string entityRef = 4;
   */
  entityRef = "";

  /**
   * @generated from field: bool runAsync = 5;
   */
  runAsync = false;

  /**
   * @generated from field: bool onlyUseCache = 6;
   */
  onlyUseCache = false;

  constructor(data?: PartialMessage<RunWorkflowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RunWorkflowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workflowName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "arguments", kind: "message", T: RunWorkflowRequest_WorkflowArgument, repeated: true },
    { no: 3, name: "entityType", kind: "enum", T: proto3.getEnumType(SuggestionEntityType) },
    { no: 4, name: "entityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "runAsync", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "onlyUseCache", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunWorkflowRequest {
    return new RunWorkflowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunWorkflowRequest {
    return new RunWorkflowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunWorkflowRequest {
    return new RunWorkflowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RunWorkflowRequest | PlainMessage<RunWorkflowRequest> | undefined, b: RunWorkflowRequest | PlainMessage<RunWorkflowRequest> | undefined): boolean {
    return proto3.util.equals(RunWorkflowRequest, a, b);
  }
}

/**
 * @generated from message protogen.RunWorkflowRequest.WorkflowArgument
 */
export class RunWorkflowRequest_WorkflowArgument extends Message<RunWorkflowRequest_WorkflowArgument> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from oneof protogen.RunWorkflowRequest.WorkflowArgument.value
   */
  value: {
    /**
     * @generated from field: string stringValue = 2;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: int32 intValue = 3;
     */
    value: number;
    case: "intValue";
  } | {
    /**
     * @generated from field: bool boolValue = 4;
     */
    value: boolean;
    case: "boolValue";
  } | {
    /**
     * @generated from field: double doubleValue = 5;
     */
    value: number;
    case: "doubleValue";
  } | {
    /**
     * @generated from field: string jsonValue = 6;
     */
    value: string;
    case: "jsonValue";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<RunWorkflowRequest_WorkflowArgument>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RunWorkflowRequest.WorkflowArgument";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stringValue", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
    { no: 3, name: "intValue", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "value" },
    { no: 4, name: "boolValue", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "value" },
    { no: 5, name: "doubleValue", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, oneof: "value" },
    { no: 6, name: "jsonValue", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunWorkflowRequest_WorkflowArgument {
    return new RunWorkflowRequest_WorkflowArgument().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunWorkflowRequest_WorkflowArgument {
    return new RunWorkflowRequest_WorkflowArgument().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunWorkflowRequest_WorkflowArgument {
    return new RunWorkflowRequest_WorkflowArgument().fromJsonString(jsonString, options);
  }

  static equals(a: RunWorkflowRequest_WorkflowArgument | PlainMessage<RunWorkflowRequest_WorkflowArgument> | undefined, b: RunWorkflowRequest_WorkflowArgument | PlainMessage<RunWorkflowRequest_WorkflowArgument> | undefined): boolean {
    return proto3.util.equals(RunWorkflowRequest_WorkflowArgument, a, b);
  }
}

/**
 * @generated from message protogen.RunWorkflowResponse
 */
export class RunWorkflowResponse extends Message<RunWorkflowResponse> {
  /**
   * @generated from field: string result = 1;
   */
  result = "";

  constructor(data?: PartialMessage<RunWorkflowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RunWorkflowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "result", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunWorkflowResponse {
    return new RunWorkflowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunWorkflowResponse {
    return new RunWorkflowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunWorkflowResponse {
    return new RunWorkflowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RunWorkflowResponse | PlainMessage<RunWorkflowResponse> | undefined, b: RunWorkflowResponse | PlainMessage<RunWorkflowResponse> | undefined): boolean {
    return proto3.util.equals(RunWorkflowResponse, a, b);
  }
}

